// "Open Gmail" beside a sign-in code: the member's own inbox, opened in a new
// tab (or the mail app on a phone) so the code is one tap away. Only the
// domain is read, so a masked address ("us***@gmail.com") works.
type Inbox = { label: string; href: string };

const INBOXES: Array<{ domains: string[]; inbox: Inbox }> = [
  {
    domains: ["gmail.com", "googlemail.com"],
    inbox: { label: "Open Gmail", href: "https://mail.google.com/mail/u/0/#inbox" },
  },
  {
    domains: ["outlook.com", "hotmail.com", "live.com", "msn.com"],
    inbox: { label: "Open Outlook", href: "https://outlook.live.com/mail/0/inbox" },
  },
  {
    domains: ["icloud.com", "me.com", "mac.com"],
    inbox: { label: "Open iCloud Mail", href: "https://www.icloud.com/mail" },
  },
  {
    domains: ["yahoo.com", "ymail.com"],
    inbox: { label: "Open Yahoo Mail", href: "https://mail.yahoo.com/" },
  },
  {
    domains: ["proton.me", "protonmail.com", "pm.me"],
    inbox: { label: "Open Proton Mail", href: "https://mail.proton.me/u/0/inbox" },
  },
];

export function inboxFor(email: string | null | undefined): Inbox | null {
  const domain = email?.split("@")[1]?.trim().toLowerCase();
  if (!domain) return null;
  return INBOXES.find((entry) => entry.domains.includes(domain))?.inbox ?? null;
}
